<template>
  <div class="product">
    <title-banner :imgType="8" :isProductDetail="false"></title-banner>
    <div class="product-con">
      <div class="product-con-ctr">
        <div class="product-con-ctr-left">
          <div class="product-title">产品中心</div>
          <el-input
              placeholder="请输入关键字"
              suffix-icon="el-icon-search"
              @change="handleEnterKey"
              v-model="query.name">
          </el-input>
          <div class="product-type-box">
            <el-collapse v-model="activeNames" @change="handleChange" accordion>
              <el-collapse-item v-for="item in productTypeList" :key="item.id" :title="item.name" :name="item.id">
                <div v-if="productList.length > 0">
                  <div class="product-name" @click="productClick(item.id)" :style="productType == item.id ? 'color: #1277E4;':''" v-for="item in productList" :key="item.id">{{item.name}}</div>
                </div>
                <div v-else style="text-indent: 20px;">暂无数据</div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="product-con-ctr-right">
          <div class="productListBox" v-for="item in productList2" :key="item.id"  @click="detailsClick(item)">
            <div class="products-box-top">
              <img :src="'/boot'+item.url" alt="">
            </div>
            <div class="products-box-con">
              <h1>{{item.name}}</h1>
              <span>{{item.description}}</span>
            </div>
            <div class="products-box-btm">
              <el-button class="products-btn">查看详情</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleBanner from "@/components/titleBanner/index.vue";
import { productsListTree, productsList, productsListNameId} from "@/utils/http";
import fa from "element-ui/src/locale/lang/fa";
export default {
  name: 'product',
  computed: {
    fa() {
      return fa
    }
  },
  components: {
    titleBanner
  },
  data() {
    return {
      query:{
        name:'',
      },
      productType:'',
      activeNames:'1',
      allProductTree: [], // 所有产品树
      productList:[], // 左侧类别下产品列表
      productListOrigin:[], // 左侧类别下产品列表
      productList2:[], // 右侧产品列表
      productTypeList:[],
    };
  },
  created() {},
  watch: {
    $route(to, from) {
      this.activeNames = to.query.id
      this.productType = to.query.id
      this.getProductsListTree()
    },
  },
  mounted() {
    if(this.$route.query.id){
      this.activeNames = this.$route.query.id
      this.productType = this.$route.query.id
    }else {
      this.productType = '1'
    }
    this.getProductsListTree()
  },
  methods:{
    async getProductsListTree(){
      const res = await productsListTree();
      this.allProductTree = res.data
      this.productTypeList = res.data.map(item=>{
        return {
          name:item.name,
          id:item.id
        }
      })


      this.getProductsList(this.productType)
      await this.getProductsListNameId()
    },
    getProductsList(id) {
      this.productListOrigin = []
      for (let i = 0; i < this.allProductTree.length; i++) {
        let item = this.allProductTree[i];
        if (id === item.id) {
          if(item.children) {
            this.productListOrigin = item.children;
            break
          }
        }
      }

      this.filterProductList()
    },
    detailsClick(item){
      console.log(item)
      this.$router.push({path:'/detail',query:{id:item.id, buyLink:item.buyLink}})
    },
    handleEnterKey(){
      this.productId = ''
      this.filterProductList()
      this.getProductsListNameId()
    },
    filterProductList() {
      if(this.productListOrigin.length === 0) {
        this.productList = []
        return
      }

      if(this.query.name) {
        let name = this.query.name
        this.productList = this.productListOrigin.filter(item=>item.name.includes(name))
      } else {
        this.productList = this.productListOrigin
      }
    },
    handleChange(val){
      this.$nextTick(async ()=>{
        this.getProductsList(val)
      })
      // 只更新 productList

      console.log(this.productList)
    },
    productClick(val){
      // 更新 productList2
      this.productId = val
      this.getProductsListNameId()
    },
    async getProductsListNameId(){
      this.productList2 = []
      this.allProductTree.forEach(item=>{
        if(item.children){
          if (this.productId) {
            item.children.forEach(item=>{
              if(this.productId === item.id){
                this.productList2 = [...this.productList2, item]
              }
            })
          } else if(this.query.name){
            item.children.forEach(item=>{
              if(item.name.includes(this.query.name)){
                this.productList2 = [...this.productList2, item]
              }
            })
          } else {
            this.productList2 = [...this.productList2, ...item.children]
          }
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.product{

  .product-con{

    &-ctr{
      width: 1200px;
      height: 840px;
      margin: 0 auto;
      padding: 30px 0;
      display: flex;
      justify-content: space-between;
      font-family: Microsoft YaHei, Microsoft YaHei;
      &-left{
        width: 248px;
        height: 840px;
        margin-right: 30px;
        overflow-y: auto;
        .product-title{
          width: 218px;
          height: 48px;
          background: #1277E4;
          margin-bottom: 30px;
          color: #fff;
          font-size: 18px;
          line-height: 48px;
          padding: 0 15px;
        }
        ::v-deep .el-input__inner{
          border: 1px solid #707070!important;
          border-radius: 0;
        }
        ::v-deep .el-input__icon{
          color: #232326;
        }
      }
      .product-type-box{
        width: 248px;
        margin-top: 30px;
        .product-name{
          margin-top: 5px;
          cursor: pointer;
          text-indent: 20px;
        }
        ::v-deep .el-collapse-item__header{
          font-weight: bold;
          font-size: 14px;
          color: #222222;
        }
      }
      ::v-deep  ::-webkit-scrollbar {
        display: none;
      }
      &-right{
        width: 940px;
        height: 840px;
        display: flex;
        flex-wrap: wrap;
        align-content: start;
        overflow-y: auto;
        .productListBox{
          width: 248px;
          height: 360px;
          cursor: pointer;
          background: #F7F7F7;
          margin:0 0 20px 20px;
          padding: 20px;
          .products-box-top{
            display: flex;
            width: 100%;
            height: 52%;
            justify-content: center;
            align-items: center;
            img{
              max-width: 70%;
              max-height: 165px;
              margin-bottom: 30px;
            }

          }

          .products-box-con{
            width: 100%;
            height: 33%;
            text-align: left;
            h1{
              font-weight: bold;
              font-size: 16px;
              color: #222222;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
            }
            span{
              display:block;
              width: 100%;
              height: 60%;
              margin-top: 20px;
              font-weight: 400;
              font-size: 14px;
              color: #666666;
              line-height: 25px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              -moz-box-orient:vertical;
            }
          }
          .products-box-btm{
            width: 100%;
            height: 15%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            color: #666666;
            cursor: pointer;
            .products-btn{
              width: 76px;
              height: 30px;
              border-radius: 0px 0px 0px 0px;
              border: 1px solid #C6C6C6;
              padding: 0;
              font-size: 13px;
              color: #1277E4;
            }
          }
        }
        .productListBox:hover{
          background: #E6E6E6;
        }
      }
    }
  }
}
</style>
